export function isProjectDesignSystemEnabledServer(): boolean {
  return process.env.DESIGN_SYSTEMS_ENABLED === 'true';
}

export function isProjectDesignSystemEnabledClient(): boolean {
  return process.env.NEXT_PUBLIC_DESIGN_SYSTEMS_ENABLED === 'true';
}
